import React from 'react';
import type { AppProps } from 'next/app';

function DesignProvider({ children }: AppProps & any) {
  return <>{children}</>;
}

export default DesignProvider;
